//
import PropTypes from 'prop-types';
import { IdleTimerProvider } from 'react-idle-timer';

// hooks
import useUsers from '../hooks/pages/useUsers';
import useAuth from '../hooks/useAuth';
import useLocalStorage from '../hooks/useLocalStorage';
// ------------------------------------------

export function IdleProvider({ children }) {

  const { trackUser } = useUsers();
  const { auth } = useAuth();
  const [, setLastActiveTime] = useLocalStorage('LAST_ACTIVE_TIME', null);

  const onActive = async () => {
    const eventTime = Date.now();
    setLastActiveTime(eventTime);

    if (auth?.token) {
      try {
        await trackUser();
      } catch (error) {
        console.error('Failed to track user activity:', error);
      }
    }
  };


  return (
    <IdleTimerProvider
      throttle={1000 * 60}
      eventsThrottle={1000 * 60}
      onActive={onActive}
      startManually
      timeout={1000 * 30}
    >
      {children}
    </IdleTimerProvider>
  )
}

IdleProvider.propTypes = {
  children: PropTypes.node
};